import {
  MinuteLyItem,
  MinuteLyItems,
  MinuteLyItemsWrap,
  MinuteLyItemThumb,
  MinuteLyItemTitle,
  MinuteLyItemTitleWrap,
  MinuteLyRailWrapper,
  MinuteLySlot,
  MinuteLySlotWrap,
  MinuteLyTitle,
} from './MinuteLy.style'
import { ICategoryTreeItem, ILightRailItem } from '../../../types'
import Link from '../../../components/Link/Link'
import { ottUtils } from '../ottUtils'

interface MinuteLyRailProps {
  data: ICategoryTreeItem
  items?: ILightRailItem[]
}

export const MinuteLyRail = ({ data, items }: MinuteLyRailProps) => {
  return (
    <MinuteLyRailWrapper key={data.id}>
      <MinuteLySlotWrap>
        <MinuteLyTitle>{data.name}</MinuteLyTitle>
        <MinuteLySlot
          className={'mintelytopvideo-slot'}
          data-slot-name='ottweb'
        />
      </MinuteLySlotWrap>
      <MinuteLyItemsWrap>
        <MinuteLyTitle>{data.dynamicData.left_title.value}</MinuteLyTitle>
        <MinuteLyItems>
          {items?.slice(0, 5).map(item => {
            return (
              <Link href={ottUtils.getAssetPath(item)} key={item.id}>
                <MinuteLyItem>
                  <MinuteLyItemThumb>
                    <img
                      src={
                        item.images[0].url +
                        `/width/260/height/${Math.round(
                          (260 * 9) / 16
                        )}/quality/70`
                      }
                      alt=''
                    />
                  </MinuteLyItemThumb>
                  <MinuteLyItemTitleWrap>
                    {/*<MinuteLyItemTopTitle></MinuteLyItemTopTitle>*/}
                    <MinuteLyItemTitle>{item.name}</MinuteLyItemTitle>
                  </MinuteLyItemTitleWrap>
                </MinuteLyItem>
              </Link>
            )
          })}
        </MinuteLyItems>
      </MinuteLyItemsWrap>
    </MinuteLyRailWrapper>
  )
}
